const ActionCable = require("actioncable");
import { Injectable } from '@angular/core';

@Injectable()
export class ActionCableService {

  isInitted: boolean;
  cable: any;

  constructor() {
    this.init();
  }

  init(): void {
    if (!this.isInitted) {
      this.cable = ActionCable.createConsumer();
      this.isInitted = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/action-cable.ts